// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JobsListSearchSection_wrapper__3CuRf","keywordsWrapper":"JobsListSearchSection_keywordsWrapper__Xc0P9","keyword":"JobsListSearchSection_keyword__r5Y79"};